import api from './api';

export const verifyCallbackSignature = async (callback, sig) => {
	const response = await api.post('/callbackSignatureVerify', {
		callback,
		sig,
	});

	return response.data;
};

const callbackSignatureService = {
	verifyCallbackSignature,
};

export default callbackSignatureService;
